import React, { useEffect, useState } from "react";
import ReactMarkdown from 'react-markdown';
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import "./CaseStudy.css";
import { useNavigate } from "react-router-dom";

export default function AdaptableLogic() {
  const navigate = useNavigate();
  const [markdown, setMarkdown] = useState('');

  useEffect(() => {
    fetch('/adaptablelogic.md')
      .then(res => res.text())
      .then(setMarkdown);
  }, []);

  return (
    <div className="case-study-content">
      <button className="back-button" onClick={() => navigate(-1)}>← Back</button>

      <div className="project-title">
        <h1>AdaptableLogic — AI Home Affordability Simulator</h1>
        <p className="subtitle">Product Manager &amp; UX Lead · Fintech · AI-Powered</p>
      </div>

      <div className="project-overview">
        <div className="overview-item">
          <strong>Role:</strong> PM &amp; UX Lead
        </div>
        <div className="overview-item">
          <strong>Duration:</strong> Aug 2025 – Present
        </div>
        <div className="overview-item">
          <strong>Tool Kit:</strong> Figma, Jira, Azure OpenAI, React
        </div>
      </div>

      <div className="case-cards">
        <div className="card-content">
          <div className="markdown-content">
            <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
              {markdown}
            </ReactMarkdown>
          </div>
        </div>
      </div>
    </div>
  );
}
